module.exports = __webpack_public_path__ + "assets/img/2021-12-active.81da0323.png";